import React from 'react'

export default function Auth({children}) {
    return (
        <>
            {children}
        </>
    )
}